import { maxWidth } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'
import styled, { css } from 'styled-components'

const Subtitle = styled.div`
    line-height:1.2;
    text-align: center;
    color: #323232;
    white-space: pre-line;

    ${props =>
      props.lh == '1.5' &&
      css`
        line-height:1.5;
      `}

    ${props =>
      props.left &&
      css`
        text-align: left;
      `}

    ${({ size }) => {
      switch (size) {
        case 'large':
          return css`
          font-size: 28px;
          `
        default:
          return css`
            font-size: 20px;

            ${maxWidth(vars.breakpoints.tablet)`
              font-size: 18px;
            `}
          `
      }
    }}

    ${({ mb}) => {
      switch (mb) {
        case 'small':
          return css`
          margin-bottom: 20px;
          `
        default:
          return css`
            margin-bottom: 50px;

            ${maxWidth(vars.breakpoints.tablet)`
              margin-bottom: 30px;
            `}
          `
      }
    }}
    
  ${maxWidth(vars.breakpoints.tablet)`
    line-height: 150%;
    white-space: unset;
    br {
      display:none;
    }
  `}

`

export default Subtitle